var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:'fm-flex ' + _vm.customClass,style:(_vm.viewStyle)},[_c('div',{class:_vm.leftFlex ? 'fm-childflex' : '',style:(_vm.leftStyle)},[_vm._t("left")],2),_vm._v(" "),_c('div',{class:_vm.rightFlex ? 'fm-childflex' : '',style:(_vm.rightStyle)},[_vm._t("right")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-437bd2fe","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/fm/FmJustifyView.vue
// module id = null
// module chunks = 